/**
 * Turn an operator-typed positive magnitude (major units, e.g. "50.00") into
 * the **negative** minor-units string the manual ledger correction endpoints
 * require (API-FIN-7: refund / chargeback amounts must be negative; wrong sign
 * → 400). Returns `null` for anything that isn't a strictly-positive amount so
 * the form can keep the submit button disabled.
 *
 * Side-effect free — unit-tested in `correction-amount.test.ts`.
 */
import { majorStringToMinorUnits } from "@/shared/lib/money";

export function toNegativeCentsString(magnitudeInput: string, currency: string): string | null {
  const minor = majorStringToMinorUnits(magnitudeInput, currency);
  if (minor === null || minor <= 0) return null;
  return String(-minor);
}
